module.exports = __webpack_public_path__ + "static/20-petsdotcom-march2000-d706dce634a8a4751b67f45dfca6f7bf.jpg";